import { render } from "./DetailIngredientSubItem.vue?vue&type=template&id=322103ef&scoped=true&ts=true"
import script from "./DetailIngredientSubItem.vue?vue&type=script&lang=ts"
export * from "./DetailIngredientSubItem.vue?vue&type=script&lang=ts"

import "./DetailIngredientSubItem.vue?vue&type=style&index=0&id=322103ef&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322103ef"]])

export default __exports__